class FacetFiltersFormMobile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initButtonListeners();
  }

  initButtonListeners() {
    this.addEventListener("click", (event) => {
      const button = event.target.closest("[data-submit-filters]");
      if (button) {
        this.onSubmitHandler(event);
        const drawerWrapper = button.closest(".mobile-facets__wrapper");
        if (drawerWrapper && button.hasAttribute("data-close-drawer")) {
          drawerWrapper.querySelector("summary").click();
        }
      }
    });
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const formsToInclude = [];
    const myForm = this.querySelector("form");
    if (myForm) formsToInclude.push(myForm);

    const sortDrawerForm = document.getElementById("FacetSortDrawerForm");
    if (sortDrawerForm) formsToInclude.push(sortDrawerForm);

    document.querySelectorAll(".pdp-bottom-facet__sort-by form").forEach((form) => {
      formsToInclude.push(form);
    });

    const searchParamsList = formsToInclude
      .map((form) => new URLSearchParams(new FormData(form)).toString())
      .filter((p) => p);

    const uniqueParams = new Set(searchParamsList);
    FacetFiltersFormIntermediate.renderPage(
      Array.from(uniqueParams).join("&"),
      event
    );
  }
}

customElements.define("facet-filters-form-mobile", FacetFiltersFormMobile);
